export function shouldSkipAutoScroll() {
  try {
    if (typeof window === 'undefined') return false;
    const hash = window.location.hash || '';
    const sessionFocus = (typeof sessionStorage !== 'undefined' && (sessionStorage.getItem('focusRestaurantId') || sessionStorage.getItem('focusHotelId')));
    return !!sessionFocus || hash.startsWith('#r-') || hash.startsWith('#h-');
  } catch (e) {
    return false;
  }
}

export function safeScrollToTop(options) {
  try {
    if (shouldSkipAutoScroll()) return;
    if (!options) window.scrollTo(0, 0);
    else window.scrollTo(options);
  } catch (e) {}
}

export function safeScrollTo(...args) {
  try {
    if (shouldSkipAutoScroll()) return;
    if (args.length === 1 && typeof args[0] === 'object') window.scrollTo(args[0]);
    else window.scrollTo(...args);
  } catch (e) {}
}

export function safeScrollBy(x, y) {
  try {
    if (shouldSkipAutoScroll()) return;
    if (typeof window.scrollBy === "function") window.scrollBy(x, y);
  } catch (e) {
    // ignore
  }
}

// Temporary global blocker for native scrolling during focused-card restore.
// Use with care: call blockAutoScroll() before navigation to booking/back and
// call unblockAutoScroll() after restoration completes. A fail-safe timeout
// will restore originals automatically.
let _originals = null;
let _blockTimeoutId = null;

export function blockAutoScroll(timeoutMs = 5000) {
  try {
    if (typeof window === 'undefined' || _originals) return;
    _originals = {
      scrollTo: window.scrollTo,
      scrollBy: window.scrollBy,
      scroll: window.scroll,
      Element_scrollIntoView: (typeof Element !== 'undefined' && Element.prototype && Element.prototype.scrollIntoView) ? Element.prototype.scrollIntoView : null,
    };

    // No-op wrappers
    window.scrollTo = function () {};
    window.scrollBy = function () {};
    window.scroll = function () {};
    try {
      if (_originals.Element_scrollIntoView) Element.prototype.scrollIntoView = function () {};
    } catch (e) {
      // ignore non-configurable
    }

    // Fail-safe: restore after timeoutMs
    _blockTimeoutId = setTimeout(() => {
      try { unblockAutoScroll(); } catch (e) {}
    }, timeoutMs);
  } catch (e) {
    // ignore
  }
}

export function unblockAutoScroll() {
  try {
    if (!_originals) return;
    if (_blockTimeoutId) { clearTimeout(_blockTimeoutId); _blockTimeoutId = null; }
    try { if (_originals.scrollTo) window.scrollTo = _originals.scrollTo; } catch (e) {}
    try { if (_originals.scrollBy) window.scrollBy = _originals.scrollBy; } catch (e) {}
    try { if (_originals.scroll) window.scroll = _originals.scroll; } catch (e) {}
    try { if (_originals.Element_scrollIntoView) Element.prototype.scrollIntoView = _originals.Element_scrollIntoView; } catch (e) {}
    _originals = null;
  } catch (e) {
    // ignore
  }
}
